// app/config/apiConfig.js
import AsyncStorage from '@react-native-async-storage/async-storage';

// Define ENVIRONMENTS object
const ENVIRONMENTS = {
  development: {
    BASE_URL: 'http://localhost:3007',
    API_VERSION: 'v1',
    DEBUG: true,
  },
  staging: {
    BASE_URL: 'https://staging-api.jobeng.ai',
    API_VERSION: 'v1',
    DEBUG: false,
  },
  production: {
    BASE_URL: 'https://api.jobeng.ai',
    API_VERSION: 'v1',
    DEBUG: false,
  },
};

// Current environment - change this based on your needs
const ENV = 'production'; // or 'development' or 'staging'

export const ENDPOINTS = {
  SUBSCRIPTION_PLANS: '/api/subscription-plans',
  BUSINESS_SUBSCRIPTIONS: '/api/business-subscriptions',
  PROFESSIONAL_SUBSCRIPTIONS: '/api/professional-subscriptions',
  LEARNING_SUBSCRIPTIONS: '/api/learning-subscriptions',
  SUBSCRIPTION_HISTORY: (id) => `/api/business-subscriptions/${id}/history`,
  SINGLE_SUBSCRIPTION: (id) => `/api/business-subscriptions/${id}`,
};

// API Configuration
export const API_CONFIG = {
  ...ENVIRONMENTS[ENV],
  BASE_URL: ENVIRONMENTS[ENV].BASE_URL,
  API_KEY: 'jobeng-web-2024',
  TIMEOUT: 15000,
  ENV: ENV,

  // Authentication endpoints
  AUTH: {
    LOGIN: '/api/auth/login',
    REGISTER: '/api/auth/register',
    LOGOUT: '/api/auth/logout',
    REFRESH_TOKEN: '/api/auth/refresh-token',
    FORGOT_PASSWORD: '/api/auth/forgot-password',
    RESET_PASSWORD: '/api/auth/reset-password',
    VERIFY_EMAIL: '/api/auth/verify-email',
    PROFILE: '/api/auth/profile',
  },

  // ERP Module endpoints
  MODULES: {
    // Core modules
    CRM: {
      DEALS: '/api/data/deals',
      LEADS: '/api/data/leads',
      CLIENTS: '/api/data/pm_clients',
      OPPORTUNITIES: '/api/data/opportunities',
      CONTACTS: '/api/data/business_contacts',
      SALES_PIPELINE: '/api/data/sales_pipeline',
      LEAD_SCORES: '/api/data/lead_scores',
      CUSTOMER_FEEDBACK: '/api/data/customer_feedback',
    },
    
    HR: {
      EMPLOYEES: '/api/employees',
      LEAVE_REQUESTS: '/api/data/hr_leave_requests',
      PERFORMANCE_REVIEWS: '/api/data/hr_performance_reviews',
      HIRING_DECISIONS: '/api/data/hiring_decisions',
      ATTENDANCE: '/api/attendance',
      DEPARTMENTS: '/api/departments',
      PAYROLL: '/api/data/salary_comparisons',
      TRAINING: '/api/data/courses',
    },
    
    FINANCE: {
      INVOICES: '/api/invoices',
      PAYMENTS: '/api/payments',
      EXPENSES: '/expenses',
      FINANCIAL_REPORTS: '/api/data/financial_reports',
      FINANCIAL_FORECASTS: '/api/data/financial_forecasts',
      BUDGET: '/api/data/budget_allocations',
      TAX: '/api/data/business_finances',
      // Inside ENDPOINTS object
PAYMENT: {
  CREATE_INTENT: '/api/create-payment-intent',
  SUBSCRIPTION_STATUS: (userId) => `/api/subscription-status/${userId}`,
  CANCEL: '/api/cancel-subscription',
},
    },
    
    PROJECTS: {
      PROJECTS: '/api/projects',
      TASKS: '/api/data/tasks',
      ACTIVITIES: '/api/data/pm_activities',
      TIME_ENTRIES: '/time-entries',
      TASK_LOGS: '/api/data/task_time_logs',
      MILESTONES: '/api/data/project_status_analytics',
      RESOURCES: '/api/data/resource_allocations',
    },
    
    INVENTORY: {
      PRODUCTS: '/api/data/file_storage',
      STOCK: '/api/data/cdn_assets',
      SUPPLIERS: '/api/data/supplier_contracts',
      PURCHASE_ORDERS: '/api/data/purchase_requisitions',
      WAREHOUSES: '/api/data/storage_analytics',
      TRANSFERS: '/api/data/data_sync_status',
    },
    
    SALES: {
      ORDERS: '/api/data/sales_pipeline',
      QUOTES: '/api/data/contract_templates',
      FORECASTING: '/api/data/forecast_models',
      COMMISSIONS: '/api/data/professional_payments',
      CUSTOMERS: '/api/customers',
      PRODUCT_CATALOG: '/api/data/campaign_assets',
      // Inside ENDPOINTS object
PAYMENT: {
  CREATE_INTENT: '/api/create-payment-intent',
  SUBSCRIPTION_STATUS: (userId) => `/api/subscription-status/${userId}`,
  CANCEL: '/api/cancel-subscription',
},
    },
    
    // Additional modules
    ANALYTICS: {
      DASHBOARDS: '/api/data/analytics',
      REPORTS: '/api/reports',
      KPIS: '/api/data/kpi_metrics',
      CUSTOM_REPORTS: '/api/data/custom_reports',
      BUSINESS_ANALYTICS: '/api/data/business_analytics',
      PREDICTIVE: '/api/data/ml_predictions',
    },
    
    MARKETING: {
      CAMPAIGNS: '/api/data/campaign_analytics',
      EMAIL_MARKETING: '/api/data/email_sequences',
      SOCIAL_MEDIA: '/api/data/business_social_media',
      CONTENT: '/api/data/content_calendar',
      SEO: '/api/data/website_analytics',
      LEAD_GENERATION: '/api/data/lead_sources',
    },
    
    MANUFACTURING: {
      PRODUCTION: '/api/data/rnd_projects',
      QUALITY_CONTROL: '/api/data/audit_checklists',
      RND: '/api/data/innovation_projects',
      BOM: '/api/data/product_roadmap',
      CAPACITY: '/api/data/capacity_planning',
      WORK_ORDERS: '/api/data/task_workflows',
    },
    
    PROCUREMENT: {
      REQUISITIONS: '/api/data/purchase_requisitions',
      SUPPLIERS: '/api/data/supplier_contracts',
      CONTRACTS: '/api/data/contracts',
      VENDORS: '/api/data/vendor_performance',
      TENDERS: '/api/data/tender_submissions',
      APPROVALS: '/api/data/approval_workflows',
    },
    
    COMPLIANCE: {
      AUDITS: '/api/data/compliance_audits',
      REGULATIONS: '/api/data/regulatory_updates',
      RISKS: '/api/data/contract_risks',
      POLICIES: '/api/data/policy_acknowledgements',
      CERTIFICATIONS: '/api/data/certification_templates',
      INCIDENTS: '/api/data/audit_trails',
    },
    
    CONTRACTS: {
      AGREEMENTS: '/api/data/contracts',
      TEMPLATES: '/api/data/contract_templates',
      RENEWALS: '/api/data/contract_renewals',
      SMART_CONTRACTS: '/api/data/smart_contracts',
      E_SIGNATURES: '/api/data/contract_signatures',
      SLA: '/api/data/contract_compliance_tracking',
    },
    
    LEARNING: {
      COURSES: '/api/data/courses',
      LEARNING_PATHS: '/api/data/learning_paths',
      PROGRESS: '/api/data/course_progress',
      CERTIFICATIONS: '/api/data/certificate_templates',
      ASSESSMENTS: '/api/data/assessment_results',
      LMS: '/api/data/learning_analytics',
    },
    
    INNOVATION: {
      IDEAS: '/api/data/innovation_ideas',
      PROJECTS: '/api/data/innovation_projects',
      BUDGET: '/api/data/innovation_budget_allocation',
      PATENTS: '/api/data/intellectual_property',
      METRICS: '/api/data/innovation_kpis',
      COLLABORATION: '/api/data/collaborative_documents',
    },
    
    SUPPORT: {
      TICKETS: '/api/data/customer_feedback',
      KNOWLEDGE_BASE: '/api/data/document_versions',
      LIVE_CHAT: '/api/data/chat_threads',
      SLA: '/api/data/contract_milestones',
      HELP_DESK: '/api/data/support_tickets',
      FEEDBACK: '/api/data/customer_feedback_analysis',
    },
    
    QUALITY: {
      TESTS: '/api/data/audit_checklists',
      INSPECTIONS: '/api/data/compliance_audits',
      STANDARDS: '/api/data/regulatory_updates',
      DEFECTS: '/api/data/quality_defects',
      IMPROVEMENT: '/api/data/process_automation_initiatives',
      SIX_SIGMA: '/api/data/quality_metrics',
    },
  },

  // Dashboard endpoints
  DASHBOARD: {
    KPIS: '/api/erp/analytics/kpis',
    SUMMARY: '/api/erp/dashboard',
    NOTIFICATIONS: '/api/erp/notifications',
    QUICK_ACTIONS: '/api/erp/quick-actions',
    RECENT_ACTIVITY: '/api/data/user_activities',
    PERFORMANCE: '/api/data/business_analytics',
  },

  // Utility endpoints
  UTILS: {
    HEALTH: '/health',
    ENDPOINTS: '/api/endpoints',
    TABLES: '/api/tables',
    PING: '/api/ping',
    TEST: '/api/test/mobile',
    STATS: '/api/erp/statistics',
    CONFIG: '/api/settings',
  },

  // Dynamic endpoints (for flexible queries)
  DYNAMIC: {
    QUERY: '/api/query',
    SEARCH: '/api/search',
    EXPORT: '/api/export',
    IMPORT: '/api/import',
    BULK: '/api/bulk',
    VALIDATE: '/api/validate',
  },

  // File and media endpoints
  MEDIA: {
    UPLOAD: '/api/upload',
    FILES: '/api/data/file_storage',
    IMAGES: '/api/data/cdn_assets',
    DOCUMENTS: '/api/data/business_documents',
    TEMPLATES: '/api/data/contract_templates',
    EXPORT_TEMPLATES: '/api/data/export_templates',
  },

  // Notification endpoints
  NOTIFICATIONS: {
    LIST: '/notifications',
    UNREAD: '/notifications?read=false',
    MARK_READ: '/notifications/:id/read',
    CLEAR: '/notifications/clear',
    PREFERENCES: '/api/data/alert_settings',
    TEMPLATES: '/api/data/alert_templates',
    PUSH: '/api/data/push_tokens',
  },

  // User management
  USERS: {
    LIST: '/api/data/users',
    PROFILE: '/api/users/:id',
    PERMISSIONS: '/api/users/:id/permissions',
    ROLES: '/api/data/user_roles',
    ACTIVITIES: '/api/data/user_activities',
    SESSIONS: '/api/data/user_login_sessions',
    PREFERENCES: '/api/data/user_preferences',
  },

  // Company management
  COMPANIES: {
    LIST: '/api/companies',
    DETAIL: '/api/companies/:id',
    DEPARTMENTS: '/api/departments',
    BRANCHES: '/api/data/company_branches',
    SETTINGS: '/api/data/company_settings',
    DOCUMENTS: '/api/data/company_documents',
  },

  // AI and Machine Learning endpoints
  AI: {
    RECOMMENDATIONS: '/api/data/ai_recommendations',
    INSIGHTS: '/api/data/ai_insights',
    PREDICTIONS: '/api/data/ml_predictions',
    CHATBOT: '/api/data/ai_agents',
    ANALYTICS: '/api/data/ml_recruitment_analytics',
    MATCHING: '/api/data/ml_candidate_matching',
    SALARY_PREDICTIONS: '/api/data/ml_salary_predictions',
    LEARNING_RECOMMENDATIONS: '/api/data/ml_course_recommendations',
  },

  // Integration endpoints
  INTEGRATIONS: {
    LIST: '/api/data/third_party_integrations',
    WEBHOOKS: '/api/data/webhook_endpoints',
    API_KEYS: '/api/data/api_keys',
    LOGS: '/api/data/integration_logs',
    SYNC: '/api/data/sync_metadata',
    CONNECTIONS: '/api/data/networking_connections',
  },

  // Security endpoints
  SECURITY: {
    AUDIT_LOGS: '/api/data/audit_logs',
    ACCESS_LOGS: '/api/data/user_login_sessions',
    PERMISSIONS: '/api/data/document_permissions',
    API_RATE_LIMITS: '/api/data/api_rate_limits',
    SECURITY_QUESTIONS: '/api/data/security_questions',
    PASSWORD_POLICIES: '/api/data/password_policies',
  },

  // Reports endpoints
  REPORTS: {
    BUSINESS: '/api/data/business_reports',
    FINANCIAL: '/api/data/financial_reports',
    CUSTOM: '/api/data/custom_reports',
    ANALYTICS: '/api/data/analytics',
    EXPORT: '/api/data/data_exports',
    SCHEDULED: '/api/data/scheduled_reports',
  },

  // Settings endpoints
  SETTINGS: {
    SYSTEM: '/api/settings',
    MODULE: '/api/data/module_settings',
    USER: '/api/data/user_preferences',
    COMPANY: '/api/data/company_settings',
    NOTIFICATION: '/api/data/alert_settings',
    INTEGRATION: '/api/data/integration_settings',
  },

  // Cache configuration
  CACHE: {
    TTL: 5 * 60 * 1000, // 5 minutes
    PREFIX: 'jobeng_erp_',
    VERSION: 'v1',
  },

  // API Headers configuration
  HEADERS: {
    DEFAULT: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-API-Version': ENVIRONMENTS[ENV].API_VERSION,
      'X-Client-Type': 'mobile-app',
      'X-Client-Version': '1.0.0',
    },
    AUTH: {
      'Authorization': 'Bearer {{token}}',
    },
    UPLOAD: {
      'Content-Type': 'multipart/form-data',
    },
  },

  // Query parameters
  QUERY_PARAMS: {
    LIMIT: '_limit',
    OFFSET: '_offset',
    SORT: '_sort',
    ORDER: '_order',
    FILTER: '_filter',
    SEARCH: '_search',
    INCLUDE: '_include',
    EXCLUDE: '_exclude',
    GROUP_BY: '_groupBy',
    AGGREGATE: '_aggregate',
    EXPAND: '_expand',
  },

  // API Error codes
  ERROR_CODES: {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    VALIDATION_ERROR: 422,
    SERVER_ERROR: 500,
    TIMEOUT: 408,
    NETWORK_ERROR: 0,
  },

  // Retry configuration
  RETRY: {
    MAX_RETRIES: 3,
    RETRY_DELAY: 1000,
    RETRY_CONDITIONS: [408, 500, 502, 503, 504],
  },

  // Upload configuration
  UPLOAD: {
    MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
    ALLOWED_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    MAX_FILES: 5,
    CHUNK_SIZE: 1024 * 1024, // 1MB chunks for large files
  },

  // WebSocket configuration
  WS: {
    URL: ENVIRONMENTS[ENV].BASE_URL.replace('http', 'ws') + '/ws',
    RECONNECT_INTERVAL: 5000,
    MAX_RECONNECT_ATTEMPTS: 10,
    HEARTBEAT_INTERVAL: 30000,
  },

  // Feature flags
  FEATURES: {
    REAL_TIME_UPDATES: true,
    OFFLINE_MODE: true,
    CACHING: true,
    ANALYTICS: true,
    PUSH_NOTIFICATIONS: true,
    BIOMETRIC_AUTH: true,
    DARK_MODE: true,
    MULTI_LANGUAGE: true,
  },

  // Analytics configuration
  ANALYTICS: {
    TRACKING_ID: 'UA-XXXXXXXXX-X',
    SESSION_TIMEOUT: 30 * 60 * 1000, // 30 minutes
    SAMPLE_RATE: 1.0,
    DEBUG: ENVIRONMENTS[ENV].DEBUG,
  },

  // Localization
  LOCALIZATION: {
    DEFAULT_LANGUAGE: 'en',
    SUPPORTED_LANGUAGES: ['en', 'es', 'fr', 'de', 'zh', 'ar'],
    FALLBACK_LANGUAGE: 'en',
  },
};

// API Service Utilities
export const API_SERVICE = {
  // Get full URL for endpoint
  getUrl: (endpoint) => {
    return `${API_CONFIG.BASE_URL}${endpoint}`;
  },

  // Get headers with authentication
  getHeaders: async (options = {}) => {
    const headers = {
      ...API_CONFIG.HEADERS.DEFAULT,
      ...options.headers,
    };

    // Add authorization token if available
    try {
      const token = await AsyncStorage.getItem('auth_token');
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.warn('Failed to get auth token:', error);
    }

    return headers;
  },

  // Get query parameters string
  buildQueryString: (params = {}) => {
    const queryParams = new URLSearchParams();
    
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          value.forEach(val => queryParams.append(key, val));
        } else {
          queryParams.append(key, value);
        }
      }
    });

    const queryString = queryParams.toString();
    return queryString ? `?${queryString}` : '';
  },

  // Check if endpoint requires authentication
  requiresAuth: (endpoint) => {
    const publicEndpoints = [
      API_CONFIG.AUTH.LOGIN,
      API_CONFIG.AUTH.REGISTER,
      API_CONFIG.AUTH.FORGOT_PASSWORD,
      API_CONFIG.AUTH.RESET_PASSWORD,
      API_CONFIG.AUTH.VERIFY_EMAIL,
      API_CONFIG.UTILS.HEALTH,
      API_CONFIG.UTILS.PING,
      API_CONFIG.UTILS.TEST,
    ];

    return !publicEndpoints.some(publicEndpoint => 
      endpoint.startsWith(publicEndpoint)
    );
  },

  // Get cache key for endpoint
  getCacheKey: (endpoint, params = {}) => {
    const paramsString = JSON.stringify(params);
    return `${API_CONFIG.CACHE.PREFIX}${API_CONFIG.CACHE.VERSION}_${endpoint}_${paramsString}`;
  },

  // Check if response should be cached
  shouldCache: (method, endpoint) => {
    const cacheableMethods = ['GET', 'HEAD'];
    const nonCacheableEndpoints = [
      '/api/auth/',
      '/api/upload',
      '/api/export',
      '/api/import',
      '/notifications',
    ];

    return cacheableMethods.includes(method.toUpperCase()) && 
           !nonCacheableEndpoints.some(nonCacheable => endpoint.includes(nonCacheable));
  },

  // Format error message
  formatError: (error, endpoint) => {
    if (error.response) {
      // Server responded with error
      const status = error.response.status;
      const message = error.response.data?.message || error.response.data?.error || 'Server error';
      
      switch (status) {
        case API_CONFIG.ERROR_CODES.UNAUTHORIZED:
          return 'Session expired. Please login again.';
        case API_CONFIG.ERROR_CODES.FORBIDDEN:
          return 'You do not have permission to access this resource.';
        case API_CONFIG.ERROR_CODES.NOT_FOUND:
          return 'The requested resource was not found.';
        case API_CONFIG.ERROR_CODES.VALIDATION_ERROR:
          return 'Validation error. Please check your input.';
        case API_CONFIG.ERROR_CODES.SERVER_ERROR:
          return 'Server error. Please try again later.';
        default:
          return `Error ${status}: ${message}`;
      }
    } else if (error.request) {
      // Request was made but no response
      return 'Network error. Please check your internet connection.';
    } else {
      // Something else happened
      return error.message || 'An unexpected error occurred.';
    }
  },

  // Validate API response
  validateResponse: (response) => {
    if (!response) {
      throw new Error('No response received from server');
    }

    if (response.error) {
      throw new Error(response.error);
    }

    return response;
  },

  // Get pagination info from response headers
  getPaginationInfo: (headers) => {
    return {
      total: parseInt(headers.get('x-total-count') || '0'),
      page: parseInt(headers.get('x-page') || '1'),
      perPage: parseInt(headers.get('x-per-page') || '20'),
      totalPages: parseInt(headers.get('x-total-pages') || '1'),
      hasNext: headers.get('x-has-next') === 'true',
      hasPrev: headers.get('x-has-prev') === 'true',
    };
  },

  // Debounce function for API calls
  debounce: (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  },

  // Throttle function for API calls
  throttle: (func, limit) => {
    let inThrottle;
    return function executedFunction(...args) {
      if (!inThrottle) {
        func(...args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  },
};

// API Client Factory
export const createApiClient = (baseURL = API_CONFIG.BASE_URL) => {
  return {
    baseURL,
    
    async request(endpoint, options = {}) {
      const url = `${this.baseURL}${endpoint}`;
      const headers = await API_SERVICE.getHeaders(options);
      
      const config = {
        ...options,
        headers,
        timeout: options.timeout || API_CONFIG.TIMEOUT,
      };

      try {
        const response = await fetch(url, config);
        
        if (!response.ok) {
          const error = new Error(`HTTP ${response.status}`);
          error.response = response;
          error.status = response.status;
          throw error;
        }

        const contentType = response.headers.get('content-type');
        let data;
        
        if (contentType && contentType.includes('application/json')) {
          data = await response.json();
        } else {
          data = await response.text();
        }

        return {
          data,
          status: response.status,
          headers: response.headers,
          ok: response.ok,
        };
      } catch (error) {
        console.error(`API Request Error (${endpoint}):`, error);
        throw API_SERVICE.formatError(error, endpoint);
      }
    },

    // CRUD operations
    async get(endpoint, params = {}, options = {}) {
      const queryString = API_SERVICE.buildQueryString(params);
      return this.request(`${endpoint}${queryString}`, {
        ...options,
        method: 'GET',
      });
    },

    async post(endpoint, data = {}, options = {}) {
      return this.request(endpoint, {
        ...options,
        method: 'POST',
        body: JSON.stringify(data),
      });
    },

    async put(endpoint, data = {}, options = {}) {
      return this.request(endpoint, {
        ...options,
        method: 'PUT',
        body: JSON.stringify(data),
      });
    },

    async patch(endpoint, data = {}, options = {}) {
      return this.request(endpoint, {
        ...options,
        method: 'PATCH',
        body: JSON.stringify(data),
      });
    },

    async delete(endpoint, options = {}) {
      return this.request(endpoint, {
        ...options,
        method: 'DELETE',
      });
    },

    // Upload file
    async upload(endpoint, file, options = {}) {
      const formData = new FormData();
      formData.append('file', file);

      return this.request(endpoint, {
        ...options,
        method: 'POST',
        headers: {
          ...options.headers,
          'Content-Type': 'multipart/form-data',
        },
        body: formData,
      });
    },

    // Batch operations
    async batch(operations = []) {
      return this.request('/api/batch', {
        method: 'POST',
        body: JSON.stringify({ operations }),
      });
    },
  };
};

// Default API client instance
export const apiClient = createApiClient();

// Export environment for conditional logic
export const IS_DEVELOPMENT = ENV === 'development';
export const IS_PRODUCTION = ENV === 'production';
export const IS_STAGING = ENV === 'staging';

// Helper function to switch environments
export const switchEnvironment = (environment) => {
  if (ENVIRONMENTS[environment]) {
    console.log(`Switching to ${environment} environment`);
    return createApiClient(ENVIRONMENTS[environment].BASE_URL);
  }
  console.warn(`Environment ${environment} not found, using default`);
  return apiClient;
};

// Feature flag check
export const isFeatureEnabled = (feature) => {
  return API_CONFIG.FEATURES?.[feature] || false;
};

// Language helper
export const getLanguage = async () => {
  try {
    return (await AsyncStorage.getItem('app_language')) || API_CONFIG.LOCALIZATION?.DEFAULT_LANGUAGE || 'en';
  } catch {
    return 'en';
  }
};

// Cache helper
export const cacheManager = {
  async set(key, data, ttl = API_CONFIG.CACHE?.TTL || 300000) {
    try {
      const item = {
        data,
        timestamp: Date.now(),
        ttl,
      };
      await AsyncStorage.setItem(key, JSON.stringify(item));
    } catch (error) {
      console.warn('Cache set failed:', error);
    }
  },

  async get(key) {
    try {
      const itemStr = await AsyncStorage.getItem(key);
      if (!itemStr) return null;

      const item = JSON.parse(itemStr);
      const now = Date.now();

      if (now - item.timestamp > item.ttl) {
        await AsyncStorage.removeItem(key);
        return null;
      }

      return item.data;
    } catch (error) {
      console.warn('Cache get failed:', error);
      return null;
    }
  },

  async remove(key) {
    try {
      await AsyncStorage.removeItem(key);
    } catch (error) {
      console.warn('Cache remove failed:', error);
    }
  },

  async clear(prefix = API_CONFIG.CACHE?.PREFIX || 'jobeng_erp_') {
    try {
      const keys = await AsyncStorage.getAllKeys();
      const cacheKeys = keys.filter(key => key.startsWith(prefix));
      await AsyncStorage.multiRemove(cacheKeys);
    } catch (error) {
      console.warn('Cache clear failed:', error);
    }
  },
};

export default API_CONFIG;
